import React from 'react';
import { motion } from 'framer-motion';
import { FiMaximize, FiStar } from 'react-icons/fi';
import { BiBed, BiBath } from 'react-icons/bi';
import SafeIcon from '../common/SafeIcon';

const listings = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop',
    price: '$2,450,000',
    address: '1284 Beverly Boulevard, Beverly Hills',
    beds: 4,
    baths: 3.5,
    sqft: '3,200',
    tag: 'Just Listed'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=80&w=800&auto=format&fit=crop',
    price: '$1,850,000',
    address: '459 Skyline Drive, Hollywood Hills',
    beds: 3,
    baths: 2,
    sqft: '2,400',
    tag: 'Featured'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=800&auto=format&fit=crop',
    price: '$3,200,000',
    address: '8910 Ocean View Ave, Malibu',
    beds: 5,
    baths: 4.5,
    sqft: '4,500',
    tag: 'Open House'
  }
];

const Listings = () => {
  return (
    <section id="listings" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-sm font-bold text-amber-600 uppercase tracking-widest mb-2"
          >
            Exclusive Properties
          </motion.h2>
          <motion.h3 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl md:text-4xl font-bold text-slate-900 font-serif"
          >
            Featured Listings
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {listings.map((listing, index) => (
            <motion.div
              key={listing.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 group cursor-pointer border border-slate-100"
            >
              <div className="relative h-64 overflow-hidden">
                <div className="absolute top-4 left-4 z-10 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-sm text-xs font-bold text-slate-900 uppercase tracking-wider">
                  {listing.tag}
                </div>
                <img 
                  src={listing.image} 
                  alt={listing.address} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-300"></div>
              </div>
              
              <div className="p-6">
                <div className="text-2xl font-bold text-slate-900 mb-2">{listing.price}</div>
                <div className="text-slate-500 mb-4 h-12 line-clamp-2">{listing.address}</div>
                
                <div className="flex items-center justify-between border-t border-slate-100 pt-4">
                  <div className="flex items-center text-slate-600">
                    <SafeIcon icon={BiBed} className="mr-1.5 text-lg" />
                    <span className="text-sm font-medium">{listing.beds} Beds</span>
                  </div>
                  <div className="flex items-center text-slate-600">
                    <SafeIcon icon={BiBath} className="mr-1.5 text-lg" />
                    <span className="text-sm font-medium">{listing.baths} Baths</span>
                  </div>
                  <div className="flex items-center text-slate-600">
                    <SafeIcon icon={FiMaximize} className="mr-1.5" />
                    <span className="text-sm font-medium">{listing.sqft} sqft</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <button className="bg-transparent border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white px-8 py-3 rounded-full font-medium transition-colors">
            View All Properties
          </button>
        </div>
      </div>
    </section>
  );
};

export default Listings;